import { render, staticRenderFns } from "./SelectionFooter.vue?vue&type=template&id=5f263e29&scoped=true"
import script from "./SelectionFooter.vue?vue&type=script&lang=js"
export * from "./SelectionFooter.vue?vue&type=script&lang=js"
import style0 from "./SelectionFooter.vue?vue&type=style&index=0&id=5f263e29&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f263e29",
  null
  
)

export default component.exports